import { Popover, Position } from '@transferwise/components';
import { Warning as AlertIcon, ArrowRight as ArrowRightIcon } from '@transferwise/icons';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import './PricingDisclaimer.less';
import styles from '../../../resources/static/less/comparison-components.module.less';

const createClassNames = (classNames) =>
  classNames.map((className) => `${styles[className]}`).join(' ');

const title = ({ params }) => (
  <span>
    <span className={createClassNames(['popover-title__route'])}>
      {params.sourceCurrency} <ArrowRightIcon /> {params.targetCurrency}
    </span>
    <FormattedMessage id="in" />
    <img
      className={createClassNames(['flag-icon'])}
      src={`https://wise.com/web-art/assets/flags/${params.targetCountry.toLowerCase()}.svg`}
      onError={`this.onerror=null;this.src=https://wise.com/web-art/assets/flags/${params.targetCurrency?.toLowerCase()}.svg`}
      alt={`${params.targetCountry.toLowerCase()}`}
    />
  </span>
);

const PricingDisclaimer = ({ messageKey, params, onClickToSeePricingDisclaimer }) => {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus
    <span
      className={styles['pricing-disclaimer']}
      role="button"
      onClick={() => onClickToSeePricingDisclaimer()}
    >
      <span className={styles['pricing-disclaimer-popover']}>
        <Popover
          title={title({ params })}
          content={<FormattedMessage values={params} id={messageKey} />}
          preferredPlacement={Position.LEFT_TOP}
        >
          <div>
            <AlertIcon
              className={styles['tw-alert-icon']}
              size={16}
              data-testid="alert-icon"
            />
          </div>
        </Popover>
      </span>
    </span>
  );
};

title.propTypes = {
  params: PropTypes.shape({
    sourceCurrency: PropTypes.string.isRequired,
    targetCurrency: PropTypes.string.isRequired,
    targetCountry: PropTypes.string.isRequired,
  }).isRequired,
};

PricingDisclaimer.propTypes = {
  params: PropTypes.shape({
    sourceCurrency: PropTypes.string.isRequired,
    targetCurrency: PropTypes.string.isRequired,
    targetCountry: PropTypes.string.isRequired,
  }).isRequired,
  messageKey: PropTypes.string.isRequired,

  onClickToSeePricingDisclaimer: PropTypes.func,
};

PricingDisclaimer.defaultProps = {
  onClickToSeePricingDisclaimer: () => {},
};

export default PricingDisclaimer;
